(function($) {
	var lastQuery = '';
	var lastFilter = '';
	var searchInProgress = false;
	var lastResultCount = 0;
	function doAjaxRequest(parameter, subindex, from, size, method, action, callback) {
        $.ajax({
            type   : method,
            url    : ajaxurl,
            data   : {
                action : action,
				query: parameter,
				subIndex: subindex,
				from: from,
				size: size
            },
            success: function(response){
                callback(response);
            }
        });
	}

	function getHighlightContent(content) {
		var string = '';
		var first = true;
		$.each(content, function(prop, value){
			if(value !== '') {
				if(!first) {
					string += '...';
				}
				string += value;
				if(first) {
					first = false;
				}
			}
		});
		return string;
	}

	function searchCallback(response) {
		response = JSON.parse(response);
		var html = "";
		var resultCount = lastResultCount;

		if(!searchInProgress) {
			if (response.total.value === 0) {
				$('body').addClass('no-results');
				$('.loader').removeClass('loading');
				return;
			} else {
				$('body').removeClass('no-results');
			}
		}
		for(var i = 0; i < response.total.value; i++) {
			if(response.hits[i] !== undefined) {
				resultCount++;
				var highlightContent = '';
				if(response.hits[i].highlight !== undefined) {
					if (response.hits[i].highlight.content !== undefined) {
						highlightContent = getHighlightContent(response.hits[i].highlight.content);
					} else if (response.hits[i].highlight.category !== undefined) {
						highlightContent = getHighlightContent(response.hits[i].highlight.category);
					}
				}
				var target = '';
                var permalink = response.hits[i]._source.permalink;
                if (!permalink) {
                    permalink = '';
                }
				if(permalink.indexOf('/uploads/') !== -1) {
					target = ' target="_blank"';
				}
				var faqAnswer = '';
				if(response.hits[i]._source.answer !== undefined) {
					faqAnswer = '<div>' + response.hits[i]._source.answer + '</div>';
				}
                var cardLink = '';
                if (permalink !== '') {
					cardLink = '<a class="card-link"' + target + ' href="' + permalink + '"><span class="link-text">' + supersearch_object.read_more + '</span></a>';
                }

                var cardContent = '';
                if (faqAnswer !== '') {
                    cardContent = '<ul class="accordion" data-accordion data-allow-all-closed="true" role="tablist">' +
                                    '<li class="accordion-item" data-accordion-item>' +
                                        '<a class="accordion-title box-entry box-entry-accordion faq-question" href="#"> ' +  response.hits[i]._source.title + '</a>' +
                                        '<div class="accordion-content" data-tab-content><span class="box-entry faq-answer">' + faqAnswer + '</span></div>' +
                                    '</li>' +
                                '</ul>';
                } else {
                    cardContent = '<h3 class="card-news-title">' + response.hits[i]._source.title + '</h3>' +
								'<p class="card-lead">' + highlightContent + '</p>' +
								'<p class="card-footer">' +
                                    cardLink +
								'</p>';
                }


				html += '<div class="row">' +
					'<div class="column">' +
						'<div class="card search">' +
						'<div class="card-divider post-type">' + response.hits[i]._source.type + '</div>' +
						'<div class="card-divider post-path">' + permalink + '</div>' +
							'<div class="card-section">' +
                                cardContent +
							'</div>' +
						'</div>' +
					'</div>' +
				'</div>';
			}
		}
		if(searchInProgress) {
			html = $('.results--area').html() + html;
		}
		$('.results-count .count').text(resultCount);
		$('.results--area').html($(html));

        $(document).foundation();


		if( response.total.value === 1 ) {
			$('.results-count .results-label').html($('.results-count .results-label').data('label-single'));
		} else {
			$('.results-count .results-label').html($('.results-count .results-label').data('label-multiple'));
		}

        //$('.accordion').foundation();

		$('.loader').removeClass('loading');
		if(response.total.value > resultCount && resultCount <= 80) {
			searchInProgress = true;
			var query = $('.ajax_search').val();
			var filter = $('.search_filter').val();
			lastResultCount = resultCount;
			doAjaxRequest(query, filter, resultCount, 20, 'POST', 'search', searchCallback);
		}
	}

    // Don't call GoogleAnalytics too early ...
    var gaTimeout = false;

	function searchEventHandler(event) {
		var query, filter;
		if($(this).hasClass('ajax_search')) {
			query = $(this).val();
			filter = $(this).siblings('.search_filter').val();
		} else {
			filter = $(this).val();
			query = $(this).siblings('.ajax_search').val();
		}
		if(query === lastQuery && filter === lastFilter && event.keyCode !== 13) {
			return;
		}
		lastQuery = query;
		lastFilter = filter;
		if(searchInProgress) {
			lastResultCount = 0;
			searchInProgress = false;
			$('.results--area').html('');
		}
		if ( $(this).val().length >= 3) {
			doAjaxRequest(query, filter, 0, 20, 'POST', 'search', searchCallback);
			//$(window).trigger('ct:supersearch:dosearch', [query]);
			$('body').addClass('search-typed');

			// add loader class
			$('.loader').addClass('loading');

			// reset class
			$('.results, body').removeClass('no-results');

			// empty results count label
			$('.results-count .count, .results-count .results-label').empty();
			$('.results--area').empty();

            if (gaTimeout) {
                clearTimeout(gaTimeout);
            }
            gaTimeout = setTimeout(function() {
                // Google Analytics
                if (ga && typeof ga === 'function') {
                    //ga('send', 'pageview', '/?s=' + query);
                    ga('send', 'event', {
                        eventCategory: 'Search',
                        eventAction: 'search_request',
                        eventLabel: query
                    });
                }

                // Matomo
                if (_paq && typeof _paq === 'object') {
                    _paq.push([
                        'trackEvent',
                        'Search',
                        'search_request',
                        query
                    ]);
                }
            }, 2500);
		}
	}

	$(document).ready(function() {
		$('.ajax_search').bindWithDelay('keyup', 1000, searchEventHandler, 300);
	});

	$(document).ready(function() {
		$('.search_filter').bindWithDelay('change', 1000, searchEventHandler, 300);
	});

	$('.ajax_search_form').on('submit', function(e) {
		e.preventDefault();
	});


	var openSearch = function() {

        // check if overlay is embedded or not
        if( $("div.search-overlay").css('position') === 'fixed' ) {
            $('body, html').addClass('search-active');
        } else {
            $('body').addClass('search-active');
		}

		setTimeout(function() {
			if($('html').hasClass('ct-mobilemenu-open')) {
				$('.ajax_search').get(1).focus();
			}
			else {
				$('.ajax_search').get(0).focus();
			}
		}, 1000);

    };

    var closeSearch = function() {

        $('body, html').removeClass('search-active');

    };

	$('.search-open').on('click', openSearch);

	$('.search-close, .close-search').on('click', closeSearch);
})(jQuery);
